/**
 * i18n bootstrap. The language is fixed by the domain (lireplus.indigo.ca ->
 * French) — see src/config/siteMode.ts. Customers switch languages by
 * navigating to the sister domain, so no runtime language toggle is needed.
 */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { getLanguage } from '../config/siteMode';
import en from './en.json';
import fr from './fr.json';

const language = getLanguage();

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    fr: { translation: fr },
  },
  lng: language,
  fallbackLng: 'en',
  interpolation: {
    // React already escapes interpolated values.
    escapeValue: false,
  },
  returnEmptyString: false,
});

// Reflect the locale in the document for accessibility and SEO.
document.documentElement.lang = i18n.t('meta.htmlLang');
document.title = i18n.t('meta.title');

export default i18n;
